import React from "react";
import styled from "styled-components";
import closeIcon from "../assets/close.png";
import { usePopupHistoryClose } from "../hooks/usePopupHistoryClose";

function PopUp2Pc({ img, close }) {
  const handleClose = usePopupHistoryClose(close)

  return (
    <Bg>
      <Container>
        <Close src={closeIcon} onClick={handleClose} />
        <Img src={img} />
      </Container>
    </Bg>
  );
}

export default PopUp2Pc;
const Bg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
  margin-bottom: 26px;
  z-index: 1001;
  max-width: 70%;
`;
const Close = styled.img`
  cursor: pointer;
  width: 30px;
  height: auto;
  z-index: 1001;
`;
const Img = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
